// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-section {
  padding: 20px;
  border-bottom: 1px solid #e2e8f0;
}

.search-container {
  display: flex;
  padding: 20px 20px 0 20px;
}

.search-bar-with-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.search-input {
  flex: 1;
  padding: 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
}

.search-input:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.filter-button-container {
  position: relative;
}

.filter-button {
  width: 44px;
  height: 44px;
  border: 1px solid #cbd5e0;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.2s ease;
}

.filter-button:hover {
  background: #f7fafc;
  border-color: #a0aec0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/SearchWithFilter.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".search-section {\n  padding: 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.search-container {\n  display: flex;\n  padding: 20px 20px 0 20px;\n}\n\n.search-bar-with-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.search-input {\n  flex: 1;\n  padding: 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #4299e1;\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.filter-button-container {\n  position: relative;\n}\n\n.filter-button {\n  width: 44px;\n  height: 44px;\n  border: 1px solid #cbd5e0;\n  background: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  transition: all 0.2s ease;\n}\n\n.filter-button:hover {\n  background: #f7fafc;\n  border-color: #a0aec0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
